import autoSchedulingPatchesModule from '../../autoScheduling';

export default instance => {
  instance.attachEvent('onBeforeLinkUpdate', (id, link) => autoSchedulingPatchesModule.preventLinkFromEmptyProject(id, link));
};
